var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSuccessNoti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 48,
    viewBox: "0 0 311 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4C35.0457 4 44 12.9543 44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4ZM32.9209 17.2783C32.2671 16.7699 31.3251 16.8875 30.8164 17.541L22.8018 27.8447C22.6237 28.0737 22.289 28.1039 22.0732 27.9102L17.0039 23.3477C16.3881 22.7935 15.439 22.8432 14.8848 23.459C14.3309 24.0746 14.3807 25.023 14.9961 25.5771L20.0664 30.1396C21.5767 31.4987 23.9226 31.2903 25.1699 29.6865L33.1836 19.3828C33.6921 18.7289 33.5748 17.7869 32.9209 17.2783Z",
    fill: "#008F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccessNoti);
export default __webpack_public_path__ + "static/media/iconSuccessNoti.f680524ce34309d4e008d25c8d51247b.svg";
export { ForwardRef as ReactComponent };